import { groupBy } from 'lib/array/arrayUtils'
import { isLEOffer } from 'lib/offer/offerTypes'

function getNameOfOffer(offer: App.AnyOffer) {
  if (isLEOffer(offer) && offer.property) {
    return offer.property.name
  }

  return offer.name
}

export function removeBedbankPropertiesWithLEOffer(offers: Array<App.AnyOffer>) {
  const offersByOfferName = groupBy(offers, offer => getNameOfOffer(offer))

  return [...offersByOfferName.values()].map(offers => offers[0])
}
